export default "__VITE_ASSET__Wc9M7TSY__"